'use client'

/**
 * Odświeżanie uprawnień na żywo.
 *
 * Problem, który to rozwiązuje: uprawnienia lądowały w localStorage przy
 * logowaniu i żyły tam do wylogowania. Admin odbierał komuś moduł, a ten dalej
 * z niego korzystał — czasem tygodniami, bo nikt się nie wylogowuje.
 *
 * Odpytujemy /api/auth/me:
 *   • przy wejściu na panel,
 *   • przy powrocie do karty (visibilitychange / focus) — najczęstszy przypadek:
 *     admin dzwoni „wyłączyłem ci CRM", człowiek przełącza się na kartę,
 *   • cyklicznie co 45 s, gdy karta jest widoczna.
 *
 * Gdy karta jest w tle, nie odpytujemy — to tylko generowałoby ruch bez
 * odbiorcy. Powrót do karty i tak wymusza odświeżenie.
 *
 * Reakcja na utratę dostępu jest w PermissionGate; tutaj wyłącznie zwozimy
 * świeży stan do store'u.
 */
import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/stores/authStore'

const INTERVAL_MS = 45_000

export default function PermissionWatcher() {
  const checkAuth = useAuthStore((s) => s.checkAuth)
  const busy = useRef(false)

  useEffect(() => {
    // Bez tokenu nie ma czego odświeżać (ekran logowania).
    const refresh = () => {
      if (busy.current) return
      if (document.visibilityState !== 'visible') return
      if (!useAuthStore.getState().token) return
      busy.current = true
      checkAuth().finally(() => { busy.current = false })
    }

    refresh()
    const timer = setInterval(refresh, INTERVAL_MS)
    document.addEventListener('visibilitychange', refresh)
    window.addEventListener('focus', refresh)

    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', refresh)
      window.removeEventListener('focus', refresh)
    }
  }, [checkAuth])

  return null
}
